<!-- <app-background-homepage></app-background-homepage> -->
<div class="">
  <mat-dialog-content style="scroll-behavior: unset; overflow: auto;">
      <p class="stepDisplay">
          <!-- <a router-Link="/">
          <img src="assets//img/back-arrow-icon-dark.svg" alt="STEP 1/4"/></a> -->
      <div class="font-14 heading">
          <h4 style="font-family: 'MontSerrat'; color:#1E2A36; font-weight: 600; font-size:24px">
            {{data?.message}}
          </h4>
      </div>
      <div class="info-box" *ngIf="data?.password">
          <span class="info-content"> Current password will only appear for users who’ve entered Email ID and password during onboarding and not for users who skipped onboarding.
          </span>
      </div>
      <!-- <div class="assessment_py-10 font-8">
          <h6 style="font-family: 'MontSerrat'; font-weight:500; font-size:16px; color:#748494;">{{data?.message2}}</h6>
      </div> -->
      <form [formGroup]="passwordForm">
          <label *ngIf="data?.password">Current Password</label>

          <div class="setup-account-input-icons" *ngIf="data?.password">
              <img class="setup-account-icon" src="assets/img/password-lock.svg" alt="" />
              <input oncopy="return false" onpaste="return false" class="form-control setup-account-input-field-left" [type]="show_button ? 'text' : 'password'" formControlName="currentPassword" placeholder="Password">
              <!-- <mat-error class="error-msg" *ngIf="p.currentPassword.touched && p.currentPassword.errors?.required">
                Required
              </mat-error> -->
              <mat-error
                class="error-msg"
                *ngIf="
                  p.currentPassword.touched && p.currentPassword.errors?.required
                "
              >
                Required
              </mat-error>
              <mat-icon class="font-16 cursor-pointer field-icon" matSuffix (click)="showPassword()">{{show_button ? 'visibility_off' : 'visibility'}}</mat-icon>
          </div>
          <label>New Password</label>

         <div class="setup-account-input-icons">
          <img class="setup-account-icon" src="assets/img/password-lock.svg" alt="" />
          <input oncopy="return false" onpaste="return false" class="form-control setup-account-input-field-left" [type]="show_button ? 'text' : 'password'" formControlName="newPassword" placeholder="Password">
          <mat-error class="error-msg" *ngIf="p.newPassword.touched && p.newPassword.errors?.required">
            Required
          </mat-error>          
          <mat-error
          class="error-msg"
          *ngIf="
            p.newPassword.touched &&
            !p.newPassword.errors?.required &&
            (p.newPassword.errors?.minlength || p.newPassword.errors?.pattern)
          "
        >
        Password should contain at least 6 characters(should contain A-Z,
          a-z, and 0-9)
        </mat-error>
          <mat-icon class="font-16 cursor-pointer field-icon" matSuffix (click)="showPassword()">{{show_button ? 'visibility_off' : 'visibility'}}</mat-icon>

      </div>

      <label>Confirm New Password</label>

        <div class="setup-account-input-icons" style="margin-bottom: 35px;">
          <img class="setup-account-icon" src="assets/img/password-lock.svg" alt="" />
          <input oncopy="return false" onpaste="return false" class="form-control setup-account-input-field-left" [type]="show_eye ? 'text' : 'password'" formControlName="confirmPassword" placeholder="Password">
          <mat-error class="error-msg" *ngIf="p.confirmPassword.touched && p.confirmPassword.errors?.required">
            Required
          </mat-error>
          
          <!-- <a (click)="showConfirmPassword()"><img style="left:900px;top:355px;" src="assets/img/password-eye.svg" alt="" /></a> -->
              <mat-icon class="font-16 cursor-pointer field-icon" matSuffix (click)="showConfirmPassword()">{{show_eye ? 'visibility_off' : 'visibility'}}</mat-icon>
              <mat-error class="error-msg" *ngIf="p.confirmPassword.touched && !p.confirmPassword.errors?.required && !isPasswordEqualToConfirmPassword()">
                The passwords don’t match, please try again
              </mat-error>
        </div>

        <!-- <div>
          <button class="btn btn-primary next-btn-block pull-right"
          type="button" (click)="passwordLogin()">NEXT</button>
          <span class="pull-left set-up-later"><a (click)="setupLater()">SET UP LATER</a></span>
        </div> -->

        <div class="assessment_pt-10">
          <button class="btn btn-primary btn-block" type="button" (click)="sendOtp()">SEND OTP TO MOBILE NUMBER</button>
      </div>
<!-- Need to do -->
      <div class="" *ngIf="user.isPassSet">
          <button class="btn btn-block btn-link resend-otp assessment_mb-0" (click)="changePasswordViaEmail()" type="button">CHANGE PASSWORD VIA EMAIL</button>
      </div>
      </form>
  </mat-dialog-content>

</div>
